import React from "react";
import MProfilePicker from "@/components/ui/atoms/MProfilePicker";

const ProfilePickerDemo: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <h1 className="text-2xl font-bold mb-6">Profile Picker Demo</h1>

      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <h2 className="text-lg font-medium mb-2">Default Profile Picker</h2>
        <p className="text-gray-600 mb-4">
          The MProfilePicker component allows users to switch between profiles.
        </p>
        <div className="flex flex-col gap-4">
          <MProfilePicker />
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <h2 className="text-lg font-medium mb-2">Usage</h2>
        <p className="text-gray-600 mb-4">
          Import and use the component in your layout:
        </p>
        <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
          {`import MProfilePicker from '@/components/ui/atoms/MProfilePicker';

// In your component:
<MProfilePicker />`}
        </pre>
      </div>

      <div className="bg-white rounded-lg shadow p-4 mb-4">
        <h2 className="text-lg font-medium mb-2">Features</h2>
        <ul className="list-disc pl-5 space-y-2 text-gray-700">
          <li>Displays the currently selected profile</li>
          <li>Shows "You" for the logged-in user</li>
          <li>Different visual states for default and selected</li>
          <li>Mobile-friendly bottom sheet for profile selection</li>
          <li>Loading states with skeleton loaders</li>
          <li>Integrates with Redux store for state management</li>
        </ul>
      </div>
    </div>
  );
};

export default ProfilePickerDemo;
